import React, { useState } from 'react';
import { Form } from 'antd';
import { CommonDrawer } from '@/components';
import CreateNotification from '@/pages/Settings/Notifications/CreateNotification';
import SettingsProductDrawerForm from '@/pages/Settings/SettingsProductDrawerForm';
import InventoryForm from './InventoryForm';

type InventoryEditState = {
  id?: string;
  isDuplicate?: boolean;
};

type InventoryDrawerState = {
  isOpen: boolean;
  name: string;
};

type InventoryDrawersProps = {
  drawerState: InventoryDrawerState;
  editID: InventoryEditState;
  productsRefreshKey: number;
  onClose: () => void;
  onInventorySuccess: () => Promise<void>;
  onProductsRefresh: () => void;
};

type DrawerView = 'inventory_form' | 'product_form';

const InventoryDrawers: React.FC<InventoryDrawersProps> = ({
  drawerState,
  editID,
  productsRefreshKey,
  onClose,
  onInventorySuccess,
  onProductsRefresh,
}) => {
  const [drawerView, setDrawerView] = useState<DrawerView>('inventory_form');
  const [inventoryFormKey, setInventoryFormKey] = useState(0);
  const [productDrawerForm] = Form.useForm();
  const [step, setStep] = useState<number>(1);

  const handleClose = () => {
    onClose();
    setDrawerView('inventory_form');
    productDrawerForm.resetFields();
    setInventoryFormKey((prev) => prev + 1);
  };

  const handleInventoryFormClose = () => {
    onClose();
    setDrawerView('inventory_form');
    setInventoryFormKey((prev) => prev + 1);
  };

  const handleProductBack = () => {
    setDrawerView('inventory_form');
    productDrawerForm.resetFields();
  };

  const handleProductsRefresh = () => {
    onProductsRefresh();
    setDrawerView('inventory_form');
    productDrawerForm.resetFields();
  };

  return (
    <CommonDrawer width={444} open={drawerState.isOpen} onClose={handleClose}>
      <div
        style={{
          display: drawerView === 'inventory_form' ? 'block' : 'none',
        }}
      >
        {drawerState.name !== 'setup_notification' ? (
          <InventoryForm
            key={inventoryFormKey}
            editID={editID}
            drawerOpen={drawerState.isOpen && drawerView === 'inventory_form'}
            onClose={handleInventoryFormClose}
            onSuccess={onInventorySuccess}
            onOpenAddProduct={() => setDrawerView('product_form')}
            productsRefreshKey={productsRefreshKey}
          />
        ) : (
          <CreateNotification
            selected={null}
            drawerOpen={drawerState.name === 'setup_notification'}
            step={step}
            setStep={setStep}
            onClose={onClose}
            isInventory={true}
            onSuccess={onInventorySuccess}
            selecteInventoryID={editID.id}
          />
        )}
      </div>

      <div
        style={{ display: drawerView === 'product_form' ? 'block' : 'none' }}
      >
        <SettingsProductDrawerForm
          form={productDrawerForm}
          id={null}
          showBackButton
          handleCloseDrawer={handleProductBack}
          handleFetchAllProduct={handleProductsRefresh}
        />
      </div>
    </CommonDrawer>
  );
};

export default InventoryDrawers;
